"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EQueuesProcessors = void 0;
var EQueuesProcessors;
(function (EQueuesProcessors) {
    EQueuesProcessors["SENDEMAIL"] = "SENDEMAIL";
    EQueuesProcessors["SENDFILES"] = "SENDFILES";
})(EQueuesProcessors || (exports.EQueuesProcessors = EQueuesProcessors = {}));
